import { background, black, border, divider, orange, text } from "@/theme/colors";

export type TLevelStyles = {
  bgcolor: string;
  border: string;
  color: string;
};

export const LEVEL_PROGRESS_BAR_SIZES = {
  circle: 44,
  pill: 62,
  separatorHeight: 4,
  separatorMinWidth: 16,
  borderWidth: 4,
} as const;

const brandBorder = `${LEVEL_PROGRESS_BAR_SIZES.borderWidth}px solid ${border.brand}`;
const mutedBorder = `${LEVEL_PROGRESS_BAR_SIZES.borderWidth}px solid ${divider.high}`;
const activeBorder = `${LEVEL_PROGRESS_BAR_SIZES.borderWidth}px solid ${orange[80]}`;

export const LEVEL_NOT_STARTED_STYLES: TLevelStyles = {
  bgcolor: background.disable,
  border: mutedBorder,
  color: black[80],
};

/**
 * The level the learner is studying now — orange ring on white.
 * Replaces the old teal ring; the teal outline only survives on the SKIP pill below.
 */
export const LEVEL_IN_PROGRESS_STYLES: TLevelStyles = {
  bgcolor: background.white,
  border: activeBorder,
  color: orange[80],
};

export const LEVEL_COMPLETED_STYLES: TLevelStyles = {
  bgcolor: background.brand,
  border: brandBorder,
  color: text.white,
};

/** Skipped at assessment, not yet learned — white pill keeping the teal outline. */
export const LEVEL_SKIP_PENDING_STYLES: TLevelStyles = {
  bgcolor: background.white,
  border: brandBorder,
  color: text.brand,
};

/** Skipped at assessment, later learned and passed — same fill as completed. */
export const LEVEL_SKIP_LEARNED_STYLES = LEVEL_COMPLETED_STYLES;

/** Whole bar disabled (e.g. subject not assessed) — same look as not-started. */
export const LEVEL_DISABLED_STYLES = LEVEL_NOT_STARTED_STYLES;
